import { IFormatter } from '../FormatterTypes';
import { TEDDisplayFloat } from '../Displayers/TEDDisplayFloat';
import { TEDParseFloat } from '../Parsers/TEDParseFloat';
import { TEDValidateNumber } from '../Validators/TEDValidateNumber';

class TEDFormatFloat implements IFormatter {
  displayer = TEDDisplayFloat.getInstance();
  parser = TEDParseFloat.getInstance();
  validator = TEDValidateNumber.getInstance();
}

export { TEDFormatFloat };
